import { configureStore } from "@reduxjs/toolkit";
import globalStore from "./slice/globalStore";
import userReducer from "./slice/userSlice";
const store = configureStore({
  reducer: {
    globalState: globalStore,
    user: userReducer,
  },
});

export default store;
